import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addCartingPersonel } from "../api/addCartingPersonel";

export const useAddCartingPersonel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => addCartingPersonel(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cartingPersonel"] });
    },
  });
};

